import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { mapSelectValue } from '../../../utils'

const MtInformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postmtonline } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()
    const intialValues = {
        filingstatus: "",
        additionaltax: null,
        specifiedwithholding: null,
        reasonforexempttax: null
    }

    const options1 = [
        {
            key: 1,
            value: 'Single or married filing separately'
        },
        { key: 2, value: 'Married filing jointly or qualifying surviving spouse' },
        { key: 3, value: 'Head of household' },
        { key: 4, value: 'Married Filing Jointly with Both Spouses Working' }
    ]

    const options2 = [{

        key: 1,
        value: 'I am exempt because I am an enrolled member of a registered tribe, I live on the reservation of that tribe, and I earn wages from work performed on that reservation. (You must complete line 1 or 2.)'
    },
    { key: 2, value: 'I am exempt because I am a member of the Reserve or National Guard and my compensation is earned under U.S.C. Title 10. (You must complete line 1 or 2.)' },
    { key: 3, value: 'I am exempt because I am a North Dakota resident' },
    { key: 4, value: ' I am exempt because I am a resident of another state living in Montana solely to be with my spouse, who is a resident of the same state and a member of the U.S. armed forces assigned to a military location in Montana' }
    ]
    const w4schema = () => {
        const baseSchema = {
            filingstatus: yup.string().required('Filing status is a required field'),
            additionaltax: yup.string().nullable(),
            specifiedwithholding: yup.string().nullable(),
            reasonforexempttax: yup.string().nullable()

        }
        return yup.object(baseSchema)
    }
    const schema = w4schema()

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MT Withholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={schema}
                    onSubmit={async (values, actions) => {
                        const data = {
                            entityId: personalstore?.personalData?.entityId,
                            essUserKey:
                                initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey:
                                essUserOnBoardingFormKey,
                            completeOnline: mode == "online" ? true : false,
                            filingStatus: values?.filingstatus,
                            extraWithholding: values?.additionaltax ? values?.additionaltax : null,
                            specifiedWithholding: values?.specifiedwithholding ? values?.specifiedwithholding : null,
                            taxYear: new Date().getFullYear(),
                            reasonForExemptTax: values?.reasonforexempttax ? values?.reasonforexempttax : null
                        }
                        const response = await postmtonline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('MtInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,

                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }
                    }}
                >
                    {(props) => (
                        <View>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '65%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Federal filing status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Federal filing status"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.filingstatus
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('filingstatus', option)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.filingstatus &&
                                            props.errors.filingstatus && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.filingstatus}
                                                </Text>
                                            )}
                                    </View>
                                </View>



                                {(props.values.reasonforexempttax === null || props.values.reasonforexempttax === '') && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ width: '65%', justifyContent: 'center' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'Enter any additional tax you want withheld from your wages each pay period'
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '30%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.additionaltax}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('additionaltax')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.additionaltax &&
                                                props.errors.additionaltax && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.additionaltax as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                )}
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Enter the amount you want to withhold from retirement distributions or unemployment compensation'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.specifiedwithholding}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('specifiedwithholding')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.specifiedwithholding &&
                                            props.errors.specifiedwithholding && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.specifiedwithholding as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>




                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '65%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Select the reason you believe you are exempt from Montana income tax withholding '}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title=" Select the reason you believe you are exempt from Montana income tax withholding "
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.reasonforexempttax
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('reasonforexempttax', option)
                                                if (option !== null && option !== '') {
                                                    props.setFieldValue('additionaltax', '')
                                                }
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.reasonforexempttax &&
                                            props.errors.reasonforexempttax && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.reasonforexempttax as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </View>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default MtInformationForm
